<template>
  <div class="d-inline-block">
    <v-btn 
      text 
      small 
      @click.stop="displayDialog" 
      :loading="loading"
      class="primary--text font-weight-bold tracking-wider"
    >
      <v-icon small class="mr-2">fas fa-print</v-icon>
      Imprimir OT
    </v-btn>

    <v-dialog v-model="display" max-width="450" persistent transition="dialog-bottom-transition">
      <v-card outlined class="modern-card overflow-hidden elevation-24">
        <!-- Header -->
        <v-sheet color="primary" class="pa-6 d-flex align-center shadow-sm">
          <v-avatar color="primary lighten-1" size="32" class="mr-3">
            <v-icon small color="white">fas fa-print</v-icon>
          </v-avatar>
          <span class="text-h6 font-weight-black white--text text-uppercase tracking-widest">Opciones de Impresión</span>
          <v-spacer></v-spacer>
          <v-btn icon color="white" small @click.stop="display = false" class="grey lighten-1 opacity-20">
            <v-icon x-small>fas fa-times</v-icon>
          </v-btn>
        </v-sheet>

        <v-card-text class="pa-8">
          <div class="bg-grey-light pa-6 rounded-xl mb-6">
             <div class="caption primary--text font-weight-black text-uppercase tracking-widest mb-4 d-flex align-center">
               <v-icon x-small color="primary" class="mr-2">fas fa-cog</v-icon> Configuración del Documento
             </div>

             <v-checkbox
                v-model="user_parameters.wodocumentprintprocesstable"
                label="Incluir tabla de procesos"
                dense
                hide-details
                color="primary"
                class="modern-checkbox mt-0 mb-3"
                @change="changeParameters"
             >
               <template v-slot:label>
                 <span class="body-2 font-weight-bold grey--text text--darken-3">Incluir tabla de procesos</span>
               </template>
             </v-checkbox>

             <v-checkbox
                v-model="user_parameters.wodocumentprintsuppliestable"
                label="Incluir tabla de materiales"
                dense
                hide-details
                color="primary"
                class="modern-checkbox mb-3"
                @change="changeParameters"
             >
               <template v-slot:label>
                 <span class="body-2 font-weight-bold grey--text text--darken-3">Incluir tabla de materiales</span>
               </template>
             </v-checkbox>

             <v-checkbox
                v-model="user_parameters.wodocumentprintsupppliesresume"
                label="Incluir resumen de materiales"
                dense
                hide-details
                color="primary"
                class="modern-checkbox mb-3"
                @change="changeParameters"
             >
               <template v-slot:label>
                 <span class="body-2 font-weight-bold grey--text text--darken-3">Incluir resumen de materiales</span>
               </template>
             </v-checkbox>

             <v-checkbox
                v-model="user_parameters.wodocumentprintorderbyfamily"
                label="Productos ordenados por familia"
                dense
                hide-details
                color="primary"
                class="modern-checkbox mb-0"
                @change="changeParameters"
             >
               <template v-slot:label>
                 <span class="body-2 font-weight-bold grey--text text--darken-3">Productos ordenados por familia</span>
               </template>
             </v-checkbox>
          </div>

          <div class="caption grey--text font-italic text-center px-4">
            Se generará un documento PDF con los productos y las opciones seleccionadas.
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-6 bg-grey-light">
          <v-btn 
            block 
            large 
            depressed 
            color="primary" 
            :loading="loading" 
            :disabled="disable_button"
            class="py-6 rounded-lg font-weight-black text-uppercase tracking-widest shadow-md"
            @click.stop="print"
          >
            <v-icon left small>fas fa-file-pdf</v-icon> Generar y Descargar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import notifications from '@/utils/notifications'
import { pdfWorkOrder } from '@/doc_generators/workOrder'
import { getWorkOrder } from '@/api/production'

export default {
  name: 'PrintWorkOrder',
  props: {
    workorder: {
      type: Object,
      required: false
    },
    workorder_id: {
      type: Number,
      required: false,
      default: 0
    },
    loadWorkOrder: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      display: false,
      loading: false,
      disable_button: false,
      user_parameters: this.$store.getters.getUserParameters || {
        wodocumentprintprocesstable: true,
        wodocumentprintsuppliestable: true,
        wodocumentprintsupppliesresume: true,
        wodocumentprintorderbyfamily: true,
      }
    }
  },
  methods: {
    displayDialog() {
      if (this.workorder || (this.workorder_id && this.loadWorkOrder)) this.display = true
      else notifications.showError('Por favor seleccione una orden de trabajo')
    },
    async print() {
      this.loading = true
      try {
        const workorder = this.loadWorkOrder ? await getWorkOrder(this.workorder_id) : this.workorder
        await pdfWorkOrder(workorder, this.$store.getters.getUser, this.user_parameters)
        this.display = false
      } catch (err) {
        notifications.showError(err)
      } finally {
        this.loading = false
      }
    },
    changeParameters() {
      this.disable_button = true
      this.$store.dispatch('updateUserParameters', this.user_parameters)
        .then(() => {
          this.disable_button = false
        })
    }
  }
}
</script>

<style scoped>
.modern-card { 
  border: 1px solid rgba(0,0,0,0.08) !important; 
  border-radius: 12px !important; 
  background-color: #fff; 
}
.bg-grey-light { background-color: #f8f9fa; }
.shadow-sm { box-shadow: 0 2px 4px rgba(0,0,0,0.05) !important; }
.shadow-md { box-shadow: 0 4px 12px rgba(var(--v-primary-base), 0.2) !important; }
.tracking-widest { letter-spacing: 2px; }
.tracking-wider { letter-spacing: 1px; }
.opacity-20 { opacity: 0.2; }
.modern-checkbox >>> .v-icon { font-size: 20px !important; }
.modern-checkbox >>> .v-label { padding-left: 8px; }
</style>